import { z } from 'zod';

import { abnPattern } from '@paid-ui/regexps/abn';

export const abnSchema = z
  .string()
  .min(1, 'Required field')
  .regex(abnPattern, 'ABN must be 11 digits');

// PWA-15625: ABN is optional for every business structure. Empty string is
// accepted; when supplied the value must still be 11 digits.
export const optionalABNSchema = z
  .string()
  .regex(abnPattern, 'ABN must be 11 digits')
  .or(z.literal(''));
